import {
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
import PrevIcon from "../../ui/Icons/PrevIcon";
// import Image from "next/image";
import assest from "../../json/assest";
// import { useRouter } from "next/router";
import { useNavigate } from "react-router";

const PurchasePageLeftHeading = (props) => {
  const router = useNavigate();
  const goBackToPurchaseRequest = () => {
    router("/purchase-requests");
  };
  return (
    <Box className={styles.msgdetails}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        className={styles.detailsTopHeading}
      >
        <Typography variant="h3" className={styles.headingStyled}>
          {props?.headingText}
        </Typography>
        <Button startIcon={<PrevIcon />} onClick={goBackToPurchaseRequest}>
          Back
        </Button>
      </Stack>
    </Box>
  );
};

export default PurchasePageLeftHeading;
